<section id="disclosures">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <footnotes></footnotes>
            </div>
        </div>
    </div>
    <div class="container">
        <disclaimers></disclaimers>
    </div>
</section>